// extracted by mini-css-extract-plugin
module.exports = {"mini_info":"App_mini_info__PSbBG","mini_info_icon":"App_mini_info_icon__cLEFG","mini_info_icon_svg":"App_mini_info_icon_svg__K0XT5","mini_info_text":"App_mini_info_text__6XF1y"};